/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 */

/* =====================================================================
 * PDP BOX (#L-77). BRINDE QUE ENTRA SOZINHO NO CARRINHO. 10/09/2026.
 *
 * O QUE FAZ: quando o Box Alto Contraste esta no carrinho, o produto do
 * brinde digital (R$ 0,00) entra junto, travado em 1 unidade. Se o Box sair
 * do carrinho, o brinde sai atras.
 *
 * POR QUE MORA NO custom.js E NAO NO theme.liquid: o custom.js ja e
 * carregado em TODA pagina da loja pelo theme.liquid, com defer. Assim o
 * conserto vale tambem no /cart e no drawer, e nao so na pagina do produto,
 * e nao foi preciso reescrever os 13 KB do theme.liquid, que e o arquivo
 * onde uma reescrita inteira pode perder alguma coisa em silencio.
 *
 * OS DOIS IDS SAO DE VARIANTE, nao de produto. Trocar produto obriga a
 * trocar o numero aqui.
 *
 * SE A CLIENTE APAGAR O BRINDE, ELE NAO VOLTA. O drawer do tema poe um
 * botao Remover em toda linha, inclusive na do brinde. Sem esta trava, ela
 * clicava em Remover e o brinde reaparecia sozinho, que e a loja discutindo
 * com a cliente. Entao: se o brinde SUMIU com o Box ainda no carrinho, isso
 * foi ela, e o brinde fica fora ate o fim da visita (sessionStorage). A trava
 * se apaga sozinha quando o carrinho fica sem o Box, para a proxima compra
 * comecar limpa. Vale so naquele navegador e naquela visita.
 *
 * A LINHA DE PROPRIEDADE (`Entrega`) E O QUE EXPLICA O ITEM DE R$ 0,00.
 * Ela aparece embaixo do nome do brinde no drawer, no /cart e TAMBEM no
 * checkout e no e-mail de confirmacao, porque propriedade de item e coisa
 * nativa da Shopify e viaja junto com o pedido. Foi por isso que ela entrou
 * no lugar de um bloco desenhado no tema: um bloco so existiria onde alguem
 * escrevesse o HTML dele.
 * NAO ESCREVER PRAZO AQUI (decisao dela, 10/09): o prazo de 18 dias uteis so
 * pode aparecer no checkout, nas politicas e no FAQ. Esta linha fala do que
 * chega na hora, que e o link, e nao do que chega depois, que e o Box.
 *
 * NAO USAR MutationObserver AQUI. Em 06/09 um observer escrevendo no DOM
 * disparou a si mesmo e TRAVOU o navegador. O jeito certo e este: escutar as
 * chamadas do carrinho e reconciliar uma vez, com trava de reentrada.
 *
 * COMO ELE SABE QUE O CARRINHO MUDOU: o tema usa fetch em uns lugares e
 * jQuery (XHR) em outros, entao os DOIS sao observados. As chamadas que este
 * arquivo faz levam o cabecalho X-PB-Brinde e sao ignoradas, senao vira laco.
 *
 * DEPOIS DE MEXER NO CARRINHO ele manda o drawer se redesenhar pelo metodo
 * do proprio tema, o _rerenderCart do elemento <cart-drawer>. Se um dia esse
 * metodo mudar de nome, o brinde continua entrando, so a tela do drawer e
 * que demora um passo para mostrar. No /cart, que nao tem esse metodo, a
 * pagina recarrega.
 * 22/09: o tema publicado em 19/09 le evento.detail dentro do _rerenderCart.
 * Chamado sem argumento, o metodo dava erro e o drawer mostrava "1 item" (so
 * o Box), embora o brinde estivesse no carrinho e fosse junto no pedido. Por
 * isso a chamada leva um evento vazio, { detail: {} }. Testado nos dois
 * jeitos antes de gravar: sem argumento da erro, com o evento mostra 2 itens.
 *
 * PAGAMENTO EXPRESSO: a loja esconde o botao Compre ja por CSS no
 * theme.liquid, entao todo mundo passa pelo carrinho e o brinde sempre pega.
 * Se alguem reativar o botao, os pedidos daquele caminho ficam sem a linha
 * do brinde, e a entrega dele volta a ser so pelo link de sempre.
 *
 * 03/10 (#M-65): O COMBO BOX + CHOCALHO ESPIRAL TAMBEM LEVA O BRINDE. O combo
 * e um pacote nativo da Shopify (produto 9057868054699). No carrinho ele
 * aparece como UMA linha, com a variante do pacote, e nao com a do Box, por
 * isso as tres variantes dele (Corujinha, Abelhinha, Joaninha) entraram na
 * lista BOXES. Combo novo que leve o Box: acrescentar as variantes aqui.
 * ===================================================================== */
(function () {
  var BOXES = [44338617188523, 48037879185579, 48037879218347, 48037879251115];
  var BRINDE = 47779245293739;
  var NOTA = { Entrega: 'Link por WhatsApp e e-mail assim que a compra for confirmada' };
  var RECUSA = 'pb-brinde-recusado';
  var CART_RX = /\/cart\/(add|change|update|clear)(\.js)?/;
  var ocupado = false;
  var relogio = null;
  var tinhaBrinde = false;

  function recusou(valor) {
    try {
      if (valor === undefined) { return sessionStorage.getItem(RECUSA) === '1'; }
      if (valor) { sessionStorage.setItem(RECUSA, '1'); } else { sessionStorage.removeItem(RECUSA); }
    } catch (e) {}
    return false;
  }

  function pega() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function manda(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-PB-Brinde': '1' },
      credentials: 'same-origin',
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); });
  }

  function redesenha() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d._rerenderCart === 'function') {
      try { d._rerenderCart({ detail: {} }); } catch (e) {}
      return;
    }
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); }
  }

  function reconcilia() {
    if (ocupado) { return; }
    ocupado = true;
    pega().then(function (cart) {
      var box = 0, brinde = 0, chave = null;
      (cart.items || []).forEach(function (i) {
        if (BOXES.indexOf(i.variant_id) !== -1) { box += i.quantity; }
        if (i.variant_id === BRINDE) { brinde += i.quantity; chave = i.key; }
      });
      if (box === 0) { recusou(false); }
      if (box > 0 && brinde === 0 && tinhaBrinde) { recusou(true); }
      tinhaBrinde = brinde > 0;
      if (box > 0 && brinde === 0 && !recusou()) { return manda('/cart/add.js', { items: [{ id: BRINDE, quantity: 1, properties: NOTA }] }).then(function () { tinhaBrinde = true; redesenha(); }); }
      if (box > 0 && brinde > 1) { return manda('/cart/change.js', { id: chave, quantity: 1 }).then(redesenha); }
      if (box === 0 && brinde > 0) { return manda('/cart/change.js', { id: chave, quantity: 0 }).then(function () { tinhaBrinde = false; redesenha(); }); }
      return null;
    }).catch(function () {}).then(function () { ocupado = false; });
  }

  function agenda() {
    clearTimeout(relogio);
    relogio = setTimeout(reconcilia, 250);
  }

  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, opcoes) {
    var url = (typeof entrada === 'string') ? entrada : ((entrada && entrada.url) || '');
    var minha = !!(opcoes && opcoes.headers && opcoes.headers['X-PB-Brinde'] === '1');
    var p = fetchOriginal.apply(this, arguments);
    if (!minha && CART_RX.test(url)) { p.then(function () { agenda(); }).catch(function () {}); }
    return p;
  };

  var abreOriginal = XMLHttpRequest.prototype.open;
  var mandaOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__pbUrl = url || '';
    return abreOriginal.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_RX.test(this.__pbUrl || '')) { this.addEventListener('loadend', agenda); }
    return mandaOriginal.apply(this, arguments);
  };

  if (document.readyState !== 'loading') { agenda(); } else { document.addEventListener('DOMContentLoaded', agenda); }
})();
